<div class="flex justify-center items-center h-full w-full">
  <ng-lottie width="128px" height="128px" [options]="{ path: '/assets/lotties/loading.json' }"></ng-lottie>
</div>
